import { IconCheck, IconCornerDownRight } from "@tabler/icons-react";
import {
  Collection,
  Header,
  ListBox,
  ListBoxItem,
  ListBoxSection,
} from "react-aria-components";
import { menuStyle } from "../Menu/menuStyle.js";
import { SimpleMenuPopover } from "../Menu/simpleMenuPopover.js";
import type { MultiSelectSection } from "./multiSelect.js";

export interface MultiSelectPopoverProps {
  sections: readonly MultiSelectSection[];
  /** Optional className applied to the Popover. Use to override the menu width. */
  popoverClassName?: string;
}

/** The popover + listbox half of a multi-select. Must be rendered inside a
 *  react-aria-components `Select` with `selectionMode="multiple"`. Exposed so
 *  bespoke triggers can reuse the standard menu rendering. */
export const MultiSelectPopover = (props: MultiSelectPopoverProps) => {
  return (
    <SimpleMenuPopover className={props.popoverClassName}>
      <ListBox items={props.sections}>
        {(section) => (
          <ListBoxSection id={section.id}>
            {section.label ? (
              <Header className={menuStyle().sectionHeader()}>
                {section.label}
              </Header>
            ) : null}
            <Collection items={section.options}>
              {(option) => (
                <ListBoxItem
                  id={option.id}
                  textValue={option.label}
                  className={menuStyle().item({
                    className: "min-w-0 justify-start",
                  })}
                >
                  {option.indent != null && option.indent > 0 ? (
                    <IconCornerDownRight
                      className="size-4 shrink-0 text-gray-400"
                      style={{
                        marginLeft: `${2 + Math.max(0, option.indent - 1) * 24}px`,
                        marginRight: "-2px",
                      }}
                    />
                  ) : null}
                  {option.icon ? (
                    <div className="shrink-0">{option.icon}</div>
                  ) : null}
                  <span className="flex-1 truncate">{option.label}</span>
                  <IconCheck
                    className={menuStyle().itemIcon({
                      className:
                        "invisible text-indigo-600 group-selected:visible",
                    })}
                  />
                </ListBoxItem>
              )}
            </Collection>
          </ListBoxSection>
        )}
      </ListBox>
    </SimpleMenuPopover>
  );
};
